(function ($) {
  var skuNotAvailableOnMarketNotificationComponent = $(".skuNotAvailableOnMarketNotificationComponent");
  if (skuNotAvailableOnMarketNotificationComponent.length > 0) {
    skuNotAvailableOnMarketNotificationComponent.slideDown("fast");
    skuNotAvailableOnMarketNotificationComponent.delay(10000).slideUp("fast");
  }
})(jQuery);